/* global $:false */

import { UUID } from 'src/public/uuid.js'

export default class BeneficialOwnerInserter {
  static init () {
    Array.from($('.js-beneficial-owners-insert')).map((select) =>
      new BeneficialOwnerInserter($(select)))
  }

  constructor ($select) {
    this.form = $($select.data('form'))
      .filter('.c-beneficial-owner')
      .last()
      .prop('outerHTML')

    this.id = $select.data('replace-id')
    const $target = $('.js-beneficial-owners')

    $select.on('click', event => {
      event.preventDefault()
      const newUUID = UUID.v4.generate()
      $target.append(this.form.split(this.id).join(newUUID))
    })
  }
}
